import { IconChevronsLeft } from '@tabler/icons'
import useStyles from './BackToArticle.styles'
import { DEBUG_MODE } from '../../utilities/config'
import { translate } from '../../utilities/language'

export default function BackToArticle(props: any) {
  const { classes } = useStyles()
  const selectedLanguage: any = props?.selectedLanguage

  return (
    <div className={classes.linkWrapper}>
      <div
        className={classes.linkWrapperInner}
        onClick={() => {
          try {
            props?.navigateRoute('/')
          } catch (e) {
            if (DEBUG_MODE) console.log(e)
          }
        }}
      >
        <IconChevronsLeft color={'#b476eeff'} />
        <div className={classes.link + ' ' + classes.backLink}>
          {translate(
            <>Back to Articles</>,
            <>Volver a Artículos</>,
            <>Retour aux Articles</>,
            <>
              <span style={{ paddingTop: '1px', display: 'inline-block' }}>
                <span aria-hidden={true} className={classes.asianTextBlock}>
                  기사
                </span>{' '}
                <span aria-hidden={true} className={classes.asianTextBlock}>
                  목록으로
                </span>{' '}
                <span aria-hidden={true} className={classes.asianTextBlock}>
                  돌아가기
                </span>
              </span>
            </>,
            selectedLanguage
          )}
        </div>
      </div>
    </div>
  )
}
